import React from "react";
import LabelField from "component/labelField/LabelField";
import t from "module/translations";
import StaffNameText from "module/staff/StaffNameText";
import Typography from "@mui/material/Typography";

interface Props {
  internalCertifierId?: number;
  externalCertifier?: string;
}

const CertificationCertifierLabelField: React.FC<Props> = ({
  internalCertifierId,
  externalCertifier,
}) => {
  return (
    <LabelField
      {...{
        caption: t.competencyManagement.certification.certifierText,
      }}
    >
      <Typography variant="body2" gutterBottom>
        {internalCertifierId && (
          <StaffNameText {...{ staffId: internalCertifierId }} />
        )}
        {externalCertifier && externalCertifier}
        {!internalCertifierId && !externalCertifier && "-"}
      </Typography>
    </LabelField>
  );
};

export default React.memo(CertificationCertifierLabelField);
